import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import download from "downloadjs";
import {
	Paper,
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn,
	RaisedButton
} from "material-ui";
import {
	actionGetHomeStats,
	actionChangeBiModuleProps,
	actionGetChildrenStats
} from "../../actions/BIModuleActions";
import {
	actionChangeLocationProps,
	actionGetProvinces,
	actionGetCities
} from "../../actions/ProvinceActions";
import { actionGenerateExcelAffiliatesPerCity } from "../../actions/GenerateExcelActions";
import { actionGetAffiliateStatusCantNow } from "../../actions/DataActions";
// BI Module
import BiChart from "../../components/BiChart/BiChart";
import BaseClass from "./BaseClass";
import Data, { value } from "./DataLibrary";
// colores
import { C_HOMBRE, C_MUJER } from "./DataConfig";
import { C_VERDE, C_VERDE_CLARO, C_ROJO, C_ROSA, C_AZUL } from "./DataConfig";
// reducers para los datos
import { R_HombresMujeresAfiliadosNoafiliados_cant } from "./DataConfig";

class indexAfiliados extends BaseClass {
	/*
   * Render functions
   */

	renderDdjjTotal(all_data) {
		const { year } = this.props.biModule;
		// proceso datos & defino colores
		const tmp = Data.reduce(
			all_data,
			R_HombresMujeresAfiliadosNoafiliados_cant
		);
		let afiliados = { name: "Afiliados" },
			noafiliados = { name: "No Afiliados" };
		for (let i in tmp) {
			const value = tmp[i]["value"];
			switch (tmp[i]["name"]) {
				case "Afiliados Hombres":
					afiliados["Hombres"] = value;
					break;
				case "Afiliados Mujeres":
					afiliados["Mujeres"] = value;
					break;
				case "No Afiliados Hombres":
					noafiliados["Hombres"] = value;
					break;
				case "No Afiliados Mujeres":
					noafiliados["Mujeres"] = value;
					break;
				default:
					throw new Error(
						`Invalid option "${tmp[i]["name"]}" in renderDdjjTotal()`
					);
			}
		}
		let data = [afiliados, noafiliados];
		const colors = {
			Hombres: C_HOMBRE,
			Mujeres: C_MUJER
		};
		return this.renderCard(
			`Acumulado de Afiliados/No Afiliados (${year})`,
			<BiChart type="bar.stacked" data={data} colors={colors} width={435} />
		);
	}
	renderDdjjxMes(all_data) {
		const { year } = this.props.biModule;
		// proceso datos & defino colores
		let data = Data.reduceByMonth(
			all_data,
			R_HombresMujeresAfiliadosNoafiliados_cant
		);
		let colors = {
			"Afiliados Hombres": C_VERDE,
			"Afiliados Mujeres": C_VERDE_CLARO,
			"No Afiliados Hombres": C_ROJO,
			"No Afiliados Mujeres": C_ROSA
		};
		return this.renderCard(
			`Cantidad de Afiliados / No Afiliados por mes (${year})`,
			<BiChart
				type="bar.stacked"
				data={data}
				colors={colors}
				width={700}
				height={400}
				YAxisWidth={150}
				YAxisInterval={0}
			/>
		);
	}
	renderAfiliadoNoAfiliadosTotal(all_data) {
		const { year } = this.props.biModule;
		// proceso datos & defino colores
		const data = Data.reduce(
			all_data,
			R_HombresMujeresAfiliadosNoafiliados_cant
		);
		// cambio el Noviembre
		for (let i in data) {
			data[i]["name"] = data[i]["name"].replace("No Afiliados", "No Afil.");
		}
		const colors = {
			"Afiliados Hombres": C_VERDE,
			"Afiliados Mujeres": C_VERDE_CLARO,
			"No Afil. Hombres": C_ROJO,
			"No Afil. Mujeres": C_ROSA
		};
		return this.renderCard(
			`Acumulado de Afiliados/No Afiliados en DDJJ (${year})`,
			<BiChart type="pie.alt" data={data} colors={colors} width={435} />
		);
	}
	renderAffiliadosActivosInactivosAVerificarTotal(dataTotal) {
		const data3 = dataTotal[0];
		const data = [
			{ name: "Afiliados Activos", value: data3.activo },
			{ name: "Afiliados Inactivos", value: data3.inactivo },
			{ name: "Afiliados A Verificar", value: data3.aVerificar }
		];
		const colors = {
			"Afiliados Activos": C_VERDE,
			"Afiliados Inactivos": C_ROJO,
			"Afiliados A Verificar": C_AZUL
		};
		const text = `Total de Afiliados: ${data3.total}`;
		return this.renderCard(
			`Estado de los Afiliados Actuales`,
			<BiChart
				type="pie.alt"
				data={data}
				colors={colors}
				width={435}
				textBottom={text}
			/>
		);
	}

	renderHijosAfiliados(childrenStats) {
		const data = [
			{ name: "Varones 0-3", value: value("menores3.m", childrenStats) },
			{ name: "Mujeres 0-3", value: value("menores3.f", childrenStats) },
			{ name: "Varones 4-12", value: value("menores12.m", childrenStats) },
			{ name: "Mujeres 4-12", value: value("menores12.f", childrenStats) },
			{ name: "Varones +12", value: value("mayores12.m", childrenStats) },
			{ name: "Mujeres +12", value: value("mayores12.f", childrenStats) }
		];
		const colors = {
			"Varones 0-3": "#ccffff",
			"Mujeres 0-3": "#ccffcc",
			"Varones 4-12": "#99ccff",
			"Mujeres 4-12": "#99ff99",
			"Varones +12": "#0099ff",
			"Mujeres +12": "#33cc33"
		};
		return this.renderCard(
			"Hijos de Afiliados Activos",
			<BiChart type="pie.alt" data={data} colors={colors} width={900} />
		);
	}

	onGenerateExcel() {
		this.props.actionGenerateExcelAffiliatesPerCity(this.returnGenerateExcel);
	}

	returnGenerateExcel(blob) {
		let fileName = "Afiliados por provincia - " + moment().format("DD-MM-YYYY");
		download(blob, fileName);
	}

	renderBlank = () => {
		let mensaje = "No se tiene datos de afiliados.";
		return (
			<TableRow key={1}>
				<TableRowColumn>
					<p>{mensaje}</p>
				</TableRowColumn>
			</TableRow>
		);
	};
	renderBodyRows = listAffi => {
		const affiliate = listAffi[0];
		return _.map(affiliate, (affi, i) => {
			let color =
				i === "activo"
					? C_VERDE
					: i === "inactivo"
						? C_ROJO
						: i === "aVerificar"
							? C_AZUL
							: "black";
			let label =
				i === "activo"
					? "ACTIVOS"
					: i === "inactivo"
						? "INACTIVOS"
						: i === "aVerificar"
							? "A VERIFICAR"
							: "TOTAL";
			return (
				<TableRow key={i} style={{ height: "16px", fontSize: "13px" }}>
					<TableRowColumn>Afiliados</TableRowColumn>
					<TableRowColumn style={{ color: color }}>{label}</TableRowColumn>
					<TableRowColumn>{affi}</TableRowColumn>
				</TableRow>
			);
		});
	};
	renderAfiliadosActuales() {
		return this.renderCard(
			"Estado de los Afiliados Actuales",
			<div className="columns-row-between bottom25">
				<Table selectable={false} style={{ width: "500px" }}>
					<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
						<TableRow>
							<TableHeaderColumn>Afiliados</TableHeaderColumn>
							<TableHeaderColumn>Estado</TableHeaderColumn>
							<TableHeaderColumn>Cantidad</TableHeaderColumn>
						</TableRow>
					</TableHeader>
					<TableBody stripedRows displayRowCheckbox={false}>
						{!_.isEmpty(this.props.listAffiModuleBI)
							? this.renderBodyRows(this.props.listAffiModuleBI)
							: this.renderBlank()}
					</TableBody>
				</Table>
			</div>
		);
	}
	render() {
		// datos
		const { childrenStats } = this.props.biModule;
		let homeStats = this.getHomeStats();
		// graficos Afiliados / No Afiliados
		const DdjjTotal = this.renderDdjjTotal(homeStats);
		const DdjjxMes = this.renderDdjjxMes(homeStats);
		const htmlDdjj = (
			<div
				style={{ display: "flex", flexDirection: "column", marginTop: "18px" }}
			>
				{DdjjxMes}
			</div>
		);
		// grafico totales
		const HijosAfiliados = this.renderHijosAfiliados(childrenStats);
		const AfiliadoNoAfiliadosTotal = this.renderAfiliadoNoAfiliadosTotal(
			homeStats
		);
		// all done
		let mapa = this.renderMapaArgentina({
			type: "card",
			title: "Filtre por provincia"
		}); //[paper,card,null]
		let header = this.renderHeaderReport({ title: "Afiliados" });
		// const afiliadosActuales = this.renderAfiliadosActuales();
		// {afiliadosActuales}
		const affiliadosNow = !_.isEmpty(this.props.listAffiModuleBI)
			? this.renderAffiliadosActivosInactivosAVerificarTotal(
					this.props.listAffiModuleBI
			  )
			: null;
		return (
			<Paper zDepth={2} style={{ padding: "30px", marginBottom: "30px" }}>
				{header}
				<RaisedButton
					primary
					label="Ranking afiliados por provincia"
					onClick={() => this.onGenerateExcel()}
					style={{ marginTop: 14 }}
				/>
				<div style={{ display: "flex", flexDirection: "row" }}>
					{htmlDdjj}
					<div style={{ flex: 1, marginLeft: "5px" }}>{mapa}</div>
				</div>
				<div className="columns-row-between" style={{ marginTop: "18px" }}>
					{!_.isEmpty(this.props.listAffiModuleBI) ? affiliadosNow : null}
				</div>
				<div className="columns-row-between" style={{ marginTop: "18px" }}>
					{DdjjTotal}
					{AfiliadoNoAfiliadosTotal}
				</div>
				<div className="columns-row-between" style={{ marginTop: "18px" }}>
					{HijosAfiliados}
				</div>
			</Paper>
		);
	}
}

function mapStateToProps(store) {
	const provincias = Data.reduceToObject(
		store.locations.provinciasList,
		"id",
		row => row.name
	);
	const biModule = Object.assign({}, store.biModule, { provincias });
	return {
		biModule: biModule,
		provincias: store.locations.provinciasList,
		ciudades: store.locations.ciudadesList,
		session: store.session,
		login: store.session.authenticated,
		rol: store.app.rol,
		listAffiModuleBI: store.data.listAffiModuleBI
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionGetHomeStats,
			actionChangeBiModuleProps,
			actionGetChildrenStats,
			actionChangeLocationProps,
			actionGetProvinces,
			actionGetCities,
			actionGetAffiliateStatusCantNow,
			actionGenerateExcelAffiliatesPerCity
		},
		dispatch
	);
}
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(indexAfiliados);



// WEBPACK FOOTER //
// ./src/screens/biCharts/indexAfiliados.js